// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CrisisSubEvent_abstract } from './../abstract/SagaSchema/CrisisSubEvent_abstract';
export class CrisisSubEvent extends CrisisSubEvent_abstract {}
